<template>
  <div id="quiz-info">
    <div class="position-relative w-100">
      <b-row class="title-name-wrp mb-2">
        <b-col cols="6">
          <div class="title-quiz mb-2">
            <div class="font-medium-5 text-black mt-2">Title Name</div>
            <div>
              <b-form-input
                class="input-title-name"
                :disabled="stepActive != 0"
                v-model="formData.titleName"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="quiz-tab">
        <b-row>
          <b-col cols="12">
            <div class="position-relative">
              <b-tabs v-model="stepActive" class="custom-tab">
                <b-tab
                  active
                  :title="'Create'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 0 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <create-page
                    :is-edit="!modeEditor"
                    :quizId="quizId"
                    @onNextStep="stepActive++"
                    :formDataInfo="formData"
                    @onSetTitleName="onSetTitleName"
                    @isHaspermission="isHaspermission"
                  />
                </b-tab>
                <b-tab
                  :title="'Permission'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 1 },
                    { bypass: modeEditor },
                  ]"
                  lazy
                >
                  <permission-page
                    :is-edit="!modeEditor"
                    :quizId="quizId"
                    @onNextStep="stepActive++"
                    @onPreviousStep="stepActive--"
                  />
                </b-tab>
                <b-tab
                  :title="'Privilege'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'text-muted': stepActive !== 2 },
                    { bypass: modeEditor },
                    { bypass: !formData.isHaspermission },
                  ]"
                  lazy
                >
                  <privilege-page
                    :is-edit="!modeEditor"
                    :quizId="quizId"
                    @onNextStep="stepActive++"
                    @onPreviousStep="stepActive--"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionPage from "../quiz-info/Components/PermissionPage.vue";
import CreatePage from "./Components/CreatePage.vue";
import PrivilegePage from "./Components/PrivilegePage.vue";

import useQuizInfo from "./hooks/useQuizInfo";
export default {
  components: { PermissionPage, CreatePage, PrivilegePage },
  setup() {
    const {
      modeEditor,
      stepActive,
      quizId,
      onNextStep,
      onPreviousStep,
      formData,
      onSetTitleName,
      isHaspermission,
    } = useQuizInfo();

    return {
      modeEditor,
      stepActive,
      quizId,
      onNextStep,
      onPreviousStep,
      formData,
      onSetTitleName,
      isHaspermission,
    };
  },
};
</script>

<style >
@import "~@/assets/css/override-styles/progress-nav.css";

#quiz-info .title-name-wrp {
  width: 106%;
  margin-left: -27px;
  margin-top: -26px;
  background-color: #ffffff;
  padding: 0 20px;
}

#quiz-info .input-title-name {
  background-color: transparent;
}
</style>